import React from 'react';
import {Message, MessageResponse} from 'stream-chat';
import {Container} from './styles';
import MessageCard from '../../../atoms/MessageCard';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../redux/reducers';

interface Props {
  messages: (MessageResponse | Message)[];
}

const ListMessages: React.FC<Props> = ({messages}) => {
  const user = useSelector((state: RootState) => ({...state.user}));
  const renderItem = (item: MessageResponse) => {
    const {text, attachments, created_at} = item;
    let image = false
    if (attachments && attachments.length > 0) {
      image = attachments[0].type === 'image'
    }
    return (!image ?
          <MessageCard
              key={item.id}
              id={item.id}
              fromCurrentUser={user.id === item?.user?.id}
              text={text}
              attachments={attachments}
              created_at={created_at}
          /> : ''
          )
  };

  return (
    <Container
      list={messages}
      renderItem={renderItem}
      renderWhenEmpty={() => <></>}
    />
  );
};

export default ListMessages;
